/*
 * @Author: your name
 * @Date: 2019-07-11 09:40:56
 * @LastEditTime: 2021-05-13 16:40:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cimdr2018/src/plugin/extendFn/globel.js
 */
/**
 * Created by ms on 2017/7/13.
 */
let cid_2021
let cid_new
let cid_2019
let cid_old

let cid_2017
let cid_2018

let url = window.location.href

if (url.includes('www.medcircle.cn')) {
  // 3132 2801
  cid_new = '3941';
  cid_2019 = '3517';
  cid_2018 = '3132'; // 2018
  cid_old = '2801'; // 2017
  cid_2017 = '1992'; // 2026

} else {
  cid_new = '3941';
  cid_2019 = '3517';
  cid_2018 = '3132'; // 2018
  cid_old = '2801';
  cid_2017 = '1992';
}

export default {
  cid_new, cid_old, cid_2017, cid_2018,cid_2021,cid_2019
}




// WEBPACK FOOTER //
// ./src/plugin/extendFn/globel.js